import ACTIONS from "./actions";

const loginReducer = (state = { username: null, id: null, menu: [], ap: "", nm: "" }, action) => {
    switch (action.type) {
        case ACTIONS.ON_LOGIN:
            return action.payload;
        case ACTIONS.ON_LOGOUT:
            return { username: null, id: null, menu: [], ap: "", nm: "" };
        default:
            return state;
    }
};

export const modReducer = (state = { mod: null }, action) => {
    switch (action.type) {
        case ACTIONS.ON_MOD_SELECT:
            return action.payload;
        default:
            return state;
    }
};

export default loginReducer;
